import { GA3 } from './GA3';
import { GA4 } from './GA4';

export interface IDatalayer {
  setError: {
    prodType: 'HOTEIS/CLUBE' | 'HOTEIS';
    params: {
      step: 1 | 2 | 3;
      name: string;
      description: string;
      type: 'system_error' | 'user_error';
    };
  };
}

export interface IDataLayerProduct {
  name: string; // Nome do Hotel.
  id: string; // O código identificador do produto, prefixado pela palavra HOTEIS ou CLUBE, no caso de adesão ao clube.
  price?: number; // Valor em reais do produto selecionado. Se for comprado com milhas enviar 0.
  brand?: string; // Deve retornar o quarto selecionado pelo usuário, prefixado pela palavra HOTEIS. Ex: ‘HOTEIS-Quarto standart’
  category?: 'HOTEIS-EARN' | 'HOTEIS-BURN' | '<vazio>'; // Retorna a forma da pagamento prefixado pela palavra HOTEIS. Ex: ‘HOTEIS-EARN (Acúmulo)’, ‘HOTEIS-BURN (Resgate)’.
  variant: string; // Deve retornar o check in e o check out separado por ‘|’ (pipe). Ex: ‘31/01/2023 | 05/02/2023’.
  metric1?: number; // O preço em milhas do produto selecionado. Se não houver pagamento, o valor será 0.
  metric9: number; // Período em dias que o usuário ficará em viagem. Sendo: “Data Volta” subtraída pela “Data Ida”.
  metric10: number; // Período em dias entre a data da pesquisa do usuário até a “Data Ida” informada por ele. Sendo: “Data Ida” subtraída pela “Data da Busca”.
  dimension70?: 'Smiles' | 'Money' | 'SMILES_MONEY' | '<vazio>'; // O tipo de tarifa do produto. Ex.: ‘Smiles’, ‘Money’, ‘SMILES_MONEY’
  dimension98: string; // Informa a quantidade de adultos, crianças e quartos. No caso de clube enviar o valor ‘<vazio>’. Ex.: ‘Adultos=3 | Criancas=2 | Quartos=2’
}

const setError = ({ prodType, params: { step, name, description, type } }: IDatalayer['setError']) => {
  window.dataLayer.push({
    event: 'error',
    type,
    prodType,
    step,
    name,
    description,
  });
};

export const DatalayerServices = {
  GA3,
  GA4,
  setError,
};
